/* eslint-disable no-unused-vars */

/* check if mobile device so can use more native functions */
function isMobile() {
  return (window.navigator.userAgent.match(/Android/i) ||
          window.navigator.userAgent.match(/webOS/i) ||
          window.navigator.userAgent.match(/iPhone/i) ||
          window.navigator.userAgent.match(/iPod/i) ||
          window.navigator.userAgent.match(/BlackBerry/i) ||
          window.navigator.userAgent.match(/Windows Phone/i) ||
          window.navigator.userAgent.match(/iPad/i));
}
